import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RecipientValidationState } from '../../reducers/recipient-validation/recipient-validation.reducer';

export const selectRecipientValidationState =
  createFeatureSelector<RecipientValidationState>('recipientValidation');

export const selectRecipientValidationLoading = createSelector(
  selectRecipientValidationState,
  (state) => state.loading,
);

export const selectRecipientValidationAttemptCount = createSelector(
  selectRecipientValidationState,
  (state) => state.attemptCount,
);

export const selectAccountEntries = createSelector(
  selectRecipientValidationState,
  (state) => state.accountEntries,
);

export const selectRecipientValidationByAccountNumber = (accountNumber: string) =>
  createSelector(selectAccountEntries, (entries) => entries[accountNumber]);

export const selectMultiITValidationLoading = createSelector(
  selectRecipientValidationState,
  (state) => state.multiValidationLoading,
);

export const selectMultiITValidationResults = createSelector(
  selectRecipientValidationState,
  (state) => state.multiValidationResults,
);

export const selectMultiITInvalidAccounts = createSelector(
  selectMultiITValidationResults,
  (results) => results.filter((result) => !result.valid),
);

export const selectMultiITAllAccountsInvalid = createSelector(
  selectMultiITValidationResults,
  selectMultiITInvalidAccounts,
  (results, invalid) => results.length > 0 && invalid.length === results.length,
);

export const selectMultiITValidationStatus = createSelector(
  selectMultiITValidationLoading,
  selectMultiITAllAccountsInvalid,
  selectMultiITInvalidAccounts,
  (loading, allInvalid, invalidAccounts) => ({ loading, allInvalid, invalidAccounts }),
);
